import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from '@/api/PMS/baseInformation/advertising';
import { fetchListByType } from '@/api/PMS/dic/dic';
import waves from '@/directive/waves'; // 水波纹指令

import advAdd from './add';
import advDetail from './detail';
export default {
  props: ['routerIdArr', 'id', 'flagId', 'activeName', 'isInitSearch'],
  components: {
    advAdd: advAdd,
    advDetail: advDetail
  },
  directives: {
    waves: waves
  },
  watch: {
    id: function id(val) {
      this.getList();
    },
    flagId: function flagId(val) {
      this.getList();
    },
    activeName: function activeName(val) {
      this.getList();
    }
  },
  data: function data() {
    return {
      isDetail: false,
      downloadLoading: false,
      list: null,
      total: null,
      listLoading: false,
      initSearch: this.isInitSearch,
      listQuery: {
        page: 1,
        limit: 10,
        buildingName: '',
        adCode: '',
        adStatus: ''
      },
      title: '',
      adId: '',
      multipleSelection: [],
      adStatus: [],
      dialogFormVisible: false,
      dialogDetailVisible: false
    };
  },
  created: function created() {
    this.getList();
    this.loadAdStatue();
  },
  methods: {
    handleDeletes: function handleDeletes() {
      var adIds = [];
      this.multipleSelection.forEach(function (row) {
        adIds.push(row.adId);
      });
      this.delete(adIds);
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
        this.$emit('refreshTree');
        this.$emit('loadMenuTab');
      }

      this.dialogFormVisible = false;
    },
    handDetailCancle: function handDetailCancle(data) {
      this.dialogDetailVisible = false;
      this.getList();

      if (data === 'advertisingEdit') {
        this.title = '编辑';
        this.dialogFormVisible = true;
      }
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      this.listQuery.dataType = this.flagId;
      this.listQuery.id = this.id;

      if (this.initSearch === true) {
        this.listQuery.buildingName = '';
        this.listQuery.adCode = '';
        this.listQuery.adStatus = '';
      }

      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    getItemDetail: function getItemDetail(adId) {
      this.adId = adId;
      this.title = '详情';
      this.dialogDetailVisible = true;
    },
    handleFilter: function handleFilter() {
      this.initSearch = false;
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.initSearch = false;
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.initSearch = false;
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.initSearch = false;
      this.multipleSelection = val;
    },
    loadAdStatue: function loadAdStatue() {
      var _this2 = this;

      fetchListByType('ad_status').then(function (r) {
        _this2.adStatus = r.data.data;
      });
    },
    // 创建
    handleCreate: function handleCreate() {
      this.adId = '';
      this.title = '添加';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(adId) {
      this.adId = adId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    delete: function _delete(adIds) {
      var _this3 = this;

      if (adIds.length > 0) {
        this.$confirm('你确定是要删除这些广告信息, 是否继续?', '提示').then(function () {
          fetchDelete(adIds).then(function (response) {
            _this3.getList();

            _this3.$emit('refreshTree');

            _this3.$emit('loadMenuTab');

            _this3.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(adId) {
      var adIds = [];
      adIds.push(adId);
      this.delete(adIds);
    }
  }
};